import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'

import useKampanieData from './hooks/useKampanieData'
import useKampanieModal from './hooks/useKampanieModal'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import KampanieTable from './components/KampanieTable'
import KampanieModal from './components/KampanieModal'
import UzytkownikFilterModal from '../../../../filter-modals/components/UzytkownikFilterModal'

export default function Kampanie() {
	const [isCreatedByFilterOpen, setIsCreatedByFilterOpen] = useState(false)
	const [selectedCreatedById, setSelectedCreatedById] = useState(null)

	const {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		clearError,
	} = useKampanieData()

	const {
		isModalOpen,
		formName,
		setFormName,
		formDescription,
		setFormDescription,
		isSaving,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
	} = useKampanieModal(loadData)

	useEffect(() => {
		if (error) {
			Swal.fire({
				title: 'Error',
				text: error,
				icon: 'error',
			}).then(() => {
				clearError()
			})
		}
	}, [error, clearError])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSort = column => {
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
		setSorting(column, newDirection)
	}

	const handleSearchChange = e => {
		updateFilters({ searchText: e.target.value })
	}

	const handleApplyCreatedByFilter = createdById => {
		updateFilters({ createdById: createdById || null })
		setSelectedCreatedById(createdById || null)
		setIsCreatedByFilterOpen(false)
	}

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder="Szukaj kampanii po nazwie..."
			/>

			<KampanieTable
				data={data}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				onEdit={openEditModal}
				onDelete={handleDelete}
				hasCreatedByFilter={!!selectedCreatedById}
				onOpenCreatedByFilter={() => setIsCreatedByFilterOpen(true)}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={data.length}
				totalCount={totalCount}
			/>
			<KampanieModal
				isOpen={isModalOpen}
				formName={formName}
				setFormName={setFormName}
				formDescription={formDescription}
				setFormDescription={setFormDescription}
				isSaving={isSaving}
				onClose={closeModal}
				onSubmit={handleSubmit}
			/>
			<UzytkownikFilterModal
				isOpen={isCreatedByFilterOpen}
				onClose={() => setIsCreatedByFilterOpen(false)}
				selectedUzytkownikId={selectedCreatedById}
				onApply={handleApplyCreatedByFilter}
				title="Filtruj po uzytkowniku"
				description="Wybierz uzytkownika, aby zawezic liste kampanii."
				applyLabel="Zastosuj"
				clearLabel="Wyczysc filtr"
			/>
		</>
	)
}
